"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.402 3.598a.69.69 0 0 1 0 .976L4.573 16.402a.69.69 0 0 1-.976-.976L15.426 3.598a.69.69 0 0 1 .975 0M6.165 4.38A1.774 1.774 0 0 0 4.38 6.165l.018 2.844c.004.596.242 1.167.664 1.589l.644.644a.69.69 0 0 1-.976.975l-.644-.644a3.65 3.65 0 0 1-1.068-2.555L3 6.174A3.154 3.154 0 0 1 6.174 3l2.844.018c.959.006 1.877.39 2.555 1.068l.588.588a.69.69 0 0 1-.975.976l-.588-.588a2.27 2.27 0 0 0-1.59-.664zm8.094 3.368a.69.69 0 0 1 .976 0l.841.84a3.154 3.154 0 0 1 0 4.461l-3.027 3.027a3.154 3.154 0 0 1-4.46 0l-.74-.74a.69.69 0 0 1 .976-.975l.74.74a1.774 1.774 0 0 0 2.509 0l3.027-3.028a1.774 1.774 0 0 0 0-2.508l-.842-.842a.69.69 0 0 1 0-.975",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 7.112a.82.82 0 1 1-1.641 0 .82.82 0 0 1 1.64 0"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UntagIcon20.js.map